/**
 * Thin React wrapper around <hw-chat>. All it does:
 *   1. Import the Web Component so customElements.define runs once.
 *   2. Render the custom tag with kebab-cased attributes React wouldn't
 *      translate on its own.
 *   3. Forward the imperative authProvider prop to the element after mount
 *      (React can't serialise a function as an HTML attribute).
 */
export { HwChat } from './HwChat.js';
export type { HwChatProps } from './HwChat.js';
